import { Grid } from '@mui/material';
import AccordionQA from '../components/faq/AccordionQA';
import Logos from '../components/faq/Logos';

const FAQ = () => {
	return (
		<Grid
			display={'grid'}
			gap={'80px'}
			padding={'80px 15%'}
		>
			<AccordionQA />
			<Grid
				className="img-box"
				px={{ xs: '5%', xxs: '10%', md: '30%' }}
			>
				<img
					src="/assets/Images/FAQ.png"
					alt="FAQ"
				/>
			</Grid>
			<Logos />
		</Grid>
	);
};

export default FAQ;
